import { HttpRequestInterceptor } from './interfaces';
import { FetchFactory } from '@kollective-frontend/ksdk-api';
import generateRequest from './utils/generateRequest';
import toResponseFromHttpResponse from './utils/toResponseFromHttpResponse';

const generateKollectiveFetchFactory = (
  interceptor: HttpRequestInterceptor
): FetchFactory => {
  return async (url: RequestInfo, opts?: RequestInit): Promise<Response> => {
    const request = await generateRequest(url, opts);
    const res = await interceptor.handle(request);
    return toResponseFromHttpResponse(res, url);
  };
};
export default generateKollectiveFetchFactory;
